import Page from 'components/Page/Page'
import {React} from 'common'
import Table from 'components/Display/Table/Table'
import {
    useCreateAccountMutation,
    useDeleteAccountMutation,
    useEditAccountMutation,
    useGetAccountQuery,
    useGetAccountsQuery,
} from 'store/Store'
import useSites from 'logic/Sites/useSites'

const Sites = () => {
    return (
        <Page>
            <Table
                itemName="site"
                paginationType="external"
                allowDelete
                allowEdit
                allowExpanded
                allowCreate
                useEditMutation={useEditAccountMutation}
                useGetQuery={useGetAccountsQuery}
                useGetByIdQuery={useGetAccountQuery}
                useCreateMutation={useCreateAccountMutation}
                useDeleteMutation={useDeleteAccountMutation}
                useModal={useSites}
            />
        </Page>
    )
}

export default Sites
